import useToggleDetailOverlay from './useToggleDetailOverlay';
import { useDispatch, useSelector } from 'react-redux';
import url from '../helpers/url';
import { catchupOverlaySetVisible } from '../store/reducers/movieOverlayScreenSlice';
import { useState } from 'react';
import { cleanupUrlWithoutReload } from '@intigral/utils/lib/helpers/browser';
import { catchupverlaySetInVisible } from '../store/reducers/movieOverlayScreenSlice';

const useCatchupDetailOverlay = () => {
    const dispatch = useDispatch();
    const [isOpenCatchupModal, setOpenCatchupModal] = useState(false);
    const [selectedCatchupItem, setSelectedCatchupItem] = useState(null);
    const movieOverlay = useSelector((state: any) => state.movieOverlay);

    const openCatchupDetailOverlay = (
        item: {
            channelGuid: string;
            paId: string;
            stationCallSign: string;
        },
        selectedItem = null,
        isMixedCatchup = false
    ) => {
        if (movieOverlay?.isCatchupVisible) {
            closeCatchupDetailOverlay();
        }
        setOpenCatchupModal(true);
        if (selectedItem) {
            setSelectedCatchupItem(item);
            dispatch(catchupverlaySetInVisible());
        } else {
            dispatch(catchupOverlaySetVisible());
        }

        url.insertParamsWithoutReload({
            channelGuid: btoa(item.channelGuid),
            paId: btoa(item.paId),
            callSign: btoa(item.stationCallSign),
            ...(isMixedCatchup ? { isMixed: 'true' } : {}),
        });
    };

    const closeCatchupDetailOverlay = () => {
        setOpenCatchupModal(false);
        setSelectedCatchupItem(null);
        cleanupUrlWithoutReload(['channelGuid']);
        cleanupUrlWithoutReload(['paId']);
        cleanupUrlWithoutReload(['callSign']);
        cleanupUrlWithoutReload(['playbackTimestamp']);
        cleanupUrlWithoutReload(['isMixed']);
        dispatch(catchupverlaySetInVisible());
    };
    return { closeCatchupDetailOverlay, isOpenCatchupModal, selectedCatchupItem, openCatchupDetailOverlay };
};

export default useCatchupDetailOverlay;
